import { useState } from "react";
import LoadingIndicator from "../../../Loading";
import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";
import {
  ApiCallStatus,
  ApiCallStatusStates,
} from "../../../../Types/ApiStatus";
import { FileUploadParameters } from "../../../../Types/FileUpload";
import { useFileUpload } from "../../../../helpers/useFileUpload";
import { UploadResultData } from "./UploadResultModal";

type UploadVolumetricsReviewFileProps = {
  file: File;
  onUploadComplete: (
    status: ApiCallStatus,
    uploadResults?: UploadResultData,
  ) => void;
};

const UploadVolumetricsReviewFile = ({
  file,
  onUploadComplete,
}: UploadVolumetricsReviewFileProps) => {
  const [shouldUpload, setShouldUpload] = useState<boolean>(true);

  const fileUploadParameters: FileUploadParameters = {
    contentType: "multipart/form-data",
    endpoint: endpoints.uploadVolumetricsReviewFile(),
    file: file,
    onSuccess: (response: any) => {
      setShouldUpload(false);

      const apiData = response?.data;      
      const uploadResults: UploadResultData = {
        productsAccepted: apiData?.AuditMetrics?.DcpsAccepted || 0,
        productsMovedForReview: apiData?.AuditMetrics?.DcpsNeedingReview || 0,
        productsSkippedDueToPriority: apiData?.AuditMetrics?.DcpsSkippedDueToPriority || 0,
      };

      onUploadComplete(ApiCallStatusStates.SUCCESS, uploadResults);
    },
    onError: (error: any) => {
      setShouldUpload(false);
      onUploadComplete(ApiCallStatusStates.ERROR);
    },
  };

  useFileUpload(fileUploadParameters);


    return (
        <LoadingIndicator isLoading={shouldUpload} />
    );
}

export default UploadVolumetricsReviewFile;
